import {
  ClientConfigurationDormerSpecificSettingsClientVariableSettingsDto,
  ClientConfigurationDormerSpecificSettingsClientVariableSettingsVisualizationType,
  ClientInformationViewModel,
  ExtraInformationForKeyViewModel
} from "@hec/api-dtos";
import {DormerRootState} from "../DormerRootState";

import { createSelector } from '@reduxjs/toolkit';
import {DormerVisualizationSettings} from "@hec/models";
import { fromMmToRenderingMeters } from "@hec/core";
export const getClientInformationSelector = (state: DormerRootState): ClientInformationViewModel | null => {

  return state.clientInformation.clientInformation;
}


export const getExtraInformationForKeySelector = (state: DormerRootState, key: string): string | null => {
  return (state.clientInformation.clientInformation?.extraInformationForKeys ?? []).find((x: ExtraInformationForKeyViewModel) => (x.key ?? '').toLowerCase() === (key ?? '').toLowerCase())?.information ?? null;
}


export const getClientConfigurationDormerSpecificSettingsClientVariableSettingsDto = createSelector(
  [getClientInformationSelector],
  (clientInformation): ClientConfigurationDormerSpecificSettingsClientVariableSettingsDto => {
    const selected = clientInformation?.dormerSpecificSettings?.clientVariableSettings;

    return {
      ...selected,
      id: selected?.id ?? 'no-id',
      visualizationType: selected?.visualizationType ?? ClientConfigurationDormerSpecificSettingsClientVariableSettingsVisualizationType.Upright,
      sizeOpeningFrameRod: selected?.sizeOpeningFrameRod ?? 0,
      sizeFramesSeparatorRod: selected?.sizeFramesSeparatorRod ?? 0,
      sizeFrameSurroundingRod: selected?.sizeFrameSurroundingRod ?? 0,
      offsetFrameGroupDepthNonPanel: selected?.offsetFrameGroupDepthNonPanel ?? 0,
      offsetFrameGroupDepthPanel: selected?.offsetFrameGroupDepthPanel ?? 0,
      offsetFrameDepthNonWindowVariation: selected?.offsetFrameDepthNonWindowVariation ?? 0,
      offsetFrameDepthWindowVariation: selected?.offsetFrameDepthWindowVariation ?? 0,
      drawThreeDimensional: selected?.drawThreeDimensional ?? true,
      drawTwoDimensionalForCustomer: selected?.drawTwoDimensionalForCustomer ?? true,
      drawTwoDimensionalForPro: selected?.drawTwoDimensionalForPro ?? true,
      drawTwoDimensionalLineMeasurementsForCustomer: selected?.drawTwoDimensionalLineMeasurementsForCustomer ?? false,
      showPriceAtStep: selected?.showPriceAtStep ?? 0,
    };
  }
);

export const getClientConfigurationDormerVisualizationSettings = createSelector(
  [getClientInformationSelector],
  (clientInformation): DormerVisualizationSettings => {
    // const selected = clientInformation?.dormerSpecificSettings?.clientVariableSettings;

    const cvSettings = clientInformation?.dormerSpecificSettings?.clientVariableSettings;
    // return {
    //   ...selected,
    //   id: selected?.id ?? 'no-id',
    //   visualizationType: selected?.visualizationType ?? ClientConfigurationDormerSpecificSettingsClientVariableSettingsVisualizationType.Upright,
    //   sizeOpeningFrameRod: selected?.sizeOpeningFrameRod ?? 0,
    //   sizeFramesSeparatorRod: selected?.sizeFramesSeparatorRod ?? 0,
    //   sizeFrameSurroundingRod: selected?.sizeFrameSurroundingRod ?? 0,
    //   offsetFrameGroupDepthNonPanel: selected?.offsetFrameGroupDepthNonPanel ?? 0,
    //   offsetFrameGroupDepthPanel: selected?.offsetFrameGroupDepthPanel ?? 0,
    //   offsetFrameDepthNonWindowVariation: selected?.offsetFrameDepthNonWindowVariation ?? 0,
    //   offsetFrameDepthWindowVariation: selected?.offsetFrameDepthWindowVariation ?? 0,
    //   drawThreeDimensional: selected?.drawThreeDimensional ?? true,
    //   drawTwoDimensionalForCustomer: selected?.drawTwoDimensionalForCustomer ?? true,
    //   drawTwoDimensionalForPro: selected?.drawTwoDimensionalForPro ?? true,
    //   drawTwoDimensionalLineMeasurementsForCustomer: selected?.drawTwoDimensionalLineMeasurementsForCustomer ?? false,
    //   showPriceAtStep: selected?.showPriceAtStep ?? 0,
    // };
    const dormerVisualizationSettings: DormerVisualizationSettings = {
      visualizationType: cvSettings?.visualizationType ?? ClientConfigurationDormerSpecificSettingsClientVariableSettingsVisualizationType.Upright,
      sizeOpeningFrameRod: cvSettings?.sizeOpeningFrameRod ?? 0,
      sizeFramesSeparatorRod: cvSettings?.sizeFramesSeparatorRod ?? 0,
      sizeFrameSurroundingRod: cvSettings?.sizeFrameSurroundingRod ?? 0,
      offsetFrameGroupDepthNonPanel: fromMmToRenderingMeters(cvSettings?.offsetFrameGroupDepthNonPanel ?? 0),
      offsetFrameGroupDepthPanel: fromMmToRenderingMeters(cvSettings?.offsetFrameGroupDepthPanel ?? 0),
      offsetFrameDepthNonWindowVariation: fromMmToRenderingMeters(cvSettings?.offsetFrameDepthNonWindowVariation ?? 0),
      offsetFrameDepthWindowVariation: fromMmToRenderingMeters(cvSettings?.offsetFrameDepthWindowVariation ?? 0),
    } as DormerVisualizationSettings;
    return dormerVisualizationSettings;
  }
);
